import { onMounted, onBeforeUnmount } from 'vue';

export function useClientResume(refresh: () => void): void {
  onMounted(() => window.addEventListener('client:resumed', refresh));
  onBeforeUnmount(() => window.removeEventListener('client:resumed', refresh));
}
